import { Signal, View } from "@lernetz/ts-lib";
import {observeProperties} from "@lernetz/ts-lib/src/Observer";
import {languageService} from "../../services/lang";
import { router } from "../../services/router";
import template from "./Navigation.html";

export class NavigationView extends View {
    constructor() {
        super({ template, data: new NavigationController() });
    }

    init() {}
}

class NavigationController {
    router = router;
    currentLang: string;
    mobileMenuOpen: boolean;
    showZoom = true;

    scrollObservable: Signal<unknown>;
    scrollHandler: any;

    constructor() {
        this.currentLang = languageService.currentLang;
        observeProperties(this.router, 'current').propertyChange.subscribe(arg => {
            if (this.router.current.route.name === 'home') {
                this.showZoom = false;
                if (!this.scrollHandler) {
                    this.scrollHandler = this.scrollObservable.subscribe(() => {
                        this.updateZoomState();
                    });
                }
            } else {
                this.showZoom = true;
            }
        });
    }
    changeLanguage(lang) {
        languageService.changeLanguage(lang, router);
    }

    mobileToRoute(urlName, params?) {
        this.mobileMenuOpen = false;
        this.router.toRoute(urlName, params);
    }

    updateZoomState() {
        const rect = document.getElementById('searchrow').getBoundingClientRect().top;
        if (rect < 0 && !this.showZoom) {
            this.showZoom = true;
        } else if (rect > 0 && this.showZoom) {
            this.showZoom = false;
        }
    }

}

